module.exports = __webpack_public_path__ + "media/images/flags/1x1/tca-e8cccfbb98648c157b25e839f1cb557a.svg";